module.exports = __webpack_public_path__ + "static/media/icomoon.0926ecc6.eot";